import api from '../utils/api';

export const saveRevenueTarget = async (targetData) => {
  const response = await api.post('/targets', targetData);
  return response.data;
};

/*
export const fetchRevenueTargets = async (financialYear) => {
  const response = await axios.get(`${API_URL}/targets`, { params: { fy: financialYear } });
  return response.data;
};
*/
/**
 * Fetches all revenue targets or filters by financial year
 */
export const fetchRevenueTargets = async (fy = '', subCountyId = '', stream = '') => {
  const response = await api.get('/targets', {
    params: { fy, subCountyId, stream }
  });
  return response.data;
};

/**
 * Deletes a revenue target from the database
 */
export const deleteRevenueTarget = async (id) => {
  const response = await api.delete(`/targets/${id}`);
  return response.data;
};